module.exports = __webpack_public_path__ + "img/chad.e99b6682.svg";